module OfficeExt {
  function appSpecificCheckOriginFunction(
    allowed_domains: string[],
    eventObj: any,
    origin: string,
    checkOriginFunction: (allowed_domains: string[], origin: string) => boolean,
  ) {
    //This should fail by default, unless overridden.
    return false;
  }
  export var appSpecificCheckOrigin: (
    allowed_domains: string[],
    eventObj: any,
    origin: string,
    checkOriginFunction: (allowed_domains: string[], origin: string) => boolean,
  ) => boolean = appSpecificCheckOriginFunction;
}
namespace Microsoft {
  export namespace Office {
    export namespace Common {
      /// <summary>
      /// ResponseSender – base class for InvokeCompleteCallback and EventHandlerProxy. It contains the information
      ///                  of the requester.This is the object who knows how to send data back to the requester.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="requesterWindow">window object of the requester who registered for an event</param>
      /// <param name="requesterUrl">url string of the requester who registered for an event</param>
      /// <param name="actionName">method name to which the response is</param>
      /// <param name="conversationId">Id of the sender who sends the response</param>
      /// <param name="correlationId">Id of orginal calling request</param>
      /// <param name="responseType">the type of response</param>
      export class ResponseSender {
        _actionName: any;
        _conversationId: any;
        _correlationId: any;
        _invokeResultCode: any;
        _requesterUrl: any;
        _requesterWindow: any;
        _responseType: any;
        _send: any;
        constructor(requesterWindow, requesterUrl, actionName, conversationId, correlationId, responseType) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "requesterWindow", mayBeNull: false },
            { name: "requesterUrl", type: String, mayBeNull: false },
            { name: "actionName", type: String, mayBeNull: false },
            { name: "conversationId", type: String, mayBeNull: false },
            { name: "correlationId", mayBeNull: false },
            { name: "responsetype", type: Number, maybeNull: false },
          ]);
          if (e) throw e;
          //window object of the requester
          this._requesterWindow = requesterWindow;
          //url of the requester
          this._requesterUrl = requesterUrl;
          //method name
          this._actionName = actionName;
          //sender Id
          this._conversationId = conversationId;
          //correlation Id
          this._correlationId = correlationId;
          //invoke result code
          this._invokeResultCode = Microsoft.Office.Common.InvokeResultCode.noError;
          //response type
          this._responseType = responseType;
          var me = this;
          //send back the response to the requester
          this._send = function (result) {
            var validateTargetMatchesRequester = function (targetOrigin, requesterUrl) {
              var parsedTargetOrigin = OSF.OUtil.parseUrl(targetOrigin);
              var parsedRequesterUrl = OSF.OUtil.parseUrl(requesterUrl);
              if (
                !parsedTargetOrigin ||
                !parsedTargetOrigin.hostname ||
                !parsedRequesterUrl ||
                !parsedRequesterUrl.hostname
              ) {
                var errorMessage =
                  "Failed to execute 'postMessage' on 'DOMWindow': The target origin provided or the recipient window's origin are undefined.";
                // let 3rd party dev know they need to provide a targetOrigin when messaging cross-origin
                XDM_DEBUG(errorMessage);
                return false;
              } else if (
                !Microsoft.Office.Common.XdmCommunicationManager.urlCompare(parsedTargetOrigin, parsedRequesterUrl)
              ) {
                var targetOriginToConsoleLog = parsedTargetOrigin
                  ? parsedTargetOrigin.protocol +
                    "//" +
                    parsedTargetOrigin.hostname +
                    (parsedTargetOrigin.port ? ":" + parsedTargetOrigin.port : "")
                  : "undefined";
                var requesterUrlToConsoleLog = parsedRequesterUrl
                  ? parsedRequesterUrl.protocol +
                    "//" +
                    parsedRequesterUrl.hostname +
                    (parsedRequesterUrl.port ? ":" + parsedRequesterUrl.port : "")
                  : "undefined";
                var errorMessage =
                  "Failed to execute 'postMessage' on 'DOMWindow': The target origin provided ('" +
                  targetOriginToConsoleLog +
                  "') does not match the recipient window's origin ('" +
                  requesterUrlToConsoleLog +
                  "').";
                // mimic browser console error when sending a 'postMessage' cross-origin and the receiver's origin doesn't match the sender's intended target origin
                XDM_DEBUG(errorMessage);
                return false;
              }
              return true;
            };

            try {
              //run validation for the inline dialog to ensure the taskpane receiving the message matches the intended targetOrigin and vice-versa
              if (me._actionName === "dialogMessageReceived" && result.targetOrigin !== "*") {
                if (result.targetOrigin) {
                  //TODO: remove once we are ready to break cross-origin inline without targetOrigin provided BUT also pass * as the targetOrigin for dialog closed events
                  if (!validateTargetMatchesRequester(result.targetOrigin, me._requesterUrl)) {
                    return;
                  }
                }
              } else if (
                me._actionName === "dialogParentMessageReceived" &&
                result.targetOrigin &&
                result.targetOrigin !== "*"
              ) {
                //not having a targetOrigin for messageChild is perfectly fine as there may be a need to send the message to everyone in AppDomains due to child redirects
                if (!validateTargetMatchesRequester(result.targetOrigin, me._requesterUrl)) {
                  return;
                }
              }

              var response = new Microsoft.Office.Common.Response(
                me._actionName,
                me._conversationId,
                me._correlationId,
                me._invokeResultCode,
                me._responseType,
                result,
              );
              //envelope result
              var envelopedResult = Microsoft.Office.Common.MessagePackager.envelope(response);
              //send result back to the caller
              me._requesterWindow.postMessage(envelopedResult, me._requesterUrl);
            } catch (ex) {
              //Log errors when it fails to _send
              OsfMsAjaxFactory.msAjaxDebug.trace("ResponseSender._send error:" + ex.message);
            }
          };
        }
        getRequesterWindow() {
          return this._requesterWindow;
        }
        getRequesterUrl() {
          return this._requesterUrl;
        }
        getActionName() {
          return this._actionName;
        }
        getConversationId() {
          return this._conversationId;
        }
        getCorrelationId() {
          return this._correlationId;
        }
        getSend() {
          return this._send;
        }
        setResultCode(resultCode) {
          this._invokeResultCode = resultCode;
        }
      }

      /// <summary>
      /// InvokeCompleteCallback - is a object which contains invocation complete callback method as well as the context of
      //  current invocation instance; This is the class who knows how to send invocation result back to the sender/requester.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="requesterWindow">window object of the requester who registered for an event</param>
      /// <param name="requesterUrl">url string of the requester who registered for an event</param>
      /// <param name="actionName">method name to which the response is</param>
      /// <param name="conversationId">Id of the sender who sends the response</param>
      /// <param name="correlationId">Id of orginal calling request</param>
      /// <param name="postCallbackHandler">optional, contains the callback method to be called once the invocation callback
      ///                                   has done its part of work</param>
      export class InvokeCompleteCallback extends ResponseSender {
        static uber: any;
        _postCallbackHandler: any;
        _send: any;
        _invokeResultCode: any;
        _requesterWindow: any;
        _actionName: any;
        _conversationId: any;
        _correlationId: any;
        _responseType: any;
        _requesterUrl: any;
        constructor(requesterWindow, requesterUrl, actionName, conversationId, correlationId, postCallbackHandler) {
          super(
            requesterWindow,
            requesterUrl,
            actionName,
            conversationId,
            correlationId,
            Microsoft.Office.Common.ResponseType.forCalling,
          );
          // callback method to be called after the memeber method invokeComplete is done.
          this._postCallbackHandler = postCallbackHandler;
          var me = this;
          // callback method to be called when invocation is completed.
          this._send = function (result, responseCode?) {
            // assign response code only if it's passed in the function call
            if (responseCode != undefined) {
              me._invokeResultCode = responseCode;
            }
            try {
              //Microsoft.Office.Common.InvokeCompleteCallback.uber.getSend().call(this, result);
              var response = new Microsoft.Office.Common.Response(
                me._actionName,
                me._conversationId,
                me._correlationId,
                me._invokeResultCode,
                me._responseType,
                result,
              );
              //envelope result
              var envelopedResult = Microsoft.Office.Common.MessagePackager.envelope(response);
              //send result back to the caller
              me._requesterWindow.postMessage(envelopedResult, me._requesterUrl);
              //give handler a chance to handle callee' side cleanup
              me._postCallbackHandler();
            } catch (ex) {
              //Log errors when it fails to _send
              OsfMsAjaxFactory.msAjaxDebug.trace("InvokeCompleteCallback._send error:" + ex.message);
            }
          };
        }
      }

      /// <summary>
      /// MessagePackager – is an utility object, contains methods for envoloping/unenvolping messages
      /// </summary>
      /// <accessibility>private</accessibility>
      export class MessagePackager {
        //serialize a Request or Response Object into a string message
        static envelope(messageObject) {
          return JSON.stringify(messageObject);
        }
        //deserialize a Request or Response Object into a string message
        static unenvelope(messageObject) {
          return JSON.parse(messageObject);
        }
      }

      /// <summary>
      /// HostTrustStatus – specifies check status of host trustworthy.
      /// </summary>
      /// <accessibility>private</accessibility>
      export enum HostTrustStatus {
        "unknown" = 0,
        "untrusted" = 1,
        "nothttps" = 2,
        "trusted" = 3,
      }

      /// <summary>
      /// MessageType – specifies different type of message.
      /// </summary>
      /// <accessibility>private</accessibility>
      export enum ResponseType {
        "forCalling" = 0,
        "forEventing" = 1,
      }

      /// <summary>
      /// ActionType – specifies different type of action to be performed on method or event
      /// </summary>
      /// <accessibility>public</accessibility>
      export enum ActionType {
        "invoke" = 0,
        "registerEvent" = 1,
        "unregisterEvent" = 2,
      }

      /// <summary>
      /// MessageType – specifies different type of message.
      /// </summary>
      /// <accessibility>private</accessibility>
      export enum MessageType {
        "request" = 0,
        "response" = 1,
      }

      /// <summary>
      /// InvokeResultCode – specifies result code of method invocation
      /// </summary>
      /// <accessibility>public</accessibility>
      export enum InvokeResultCode {
        //no error
        "noError" = 0,
        //error in constructing or sending request on sender side
        "errorInRequest" = -1,
        //error in handling request on receiver side
        "errorHandlingRequest" = -2,
        //the requested method returns an error or error in sending
        //response on receiver side
        "errorInResponse" = -3,
        //error in handling response on sender side
        "errorHandlingResponse" = -4,
        //error in handling request on receiver side, policy check failed, access denied
        "errorHandlingRequestAccessDenied" = -5,
        //error in method call, timeout happened
        "errorHandlingMethodCallTimedout" = -6,
      }

      /// <summary>
      /// InvokeType – specifies different type of method invocation
      /// </summary>
      /// <accessibility>public</accessibility>
      export enum InvokeType {
        "async" = 0,
        "sync" = 1,
        "asyncRegisterEvent" = 2,
        "asyncUnregisterEvent" = 3,
        "syncRegisterEvent" = 4,
        "syncUnregisterEvent" = 5,
      }

      /// <summary>
      /// XdmCommunicationManager – is a Singleton object, a facade object contains all the public methods used
      ///                           by caller and callee
      /// </summary>
      /// <accessibility>public</accessibility>
      export let XdmCommunicationManager = (function () {
        //array, contains a queue of Invokers
        var _invokerQueue = [];
        //the time the last message was processed
        var _lastMessageProcessTime = null;
        //the timer handler
        var _messageProcessingTimer = null;
        //the time interval, default to 10ms
        var _processInterval = 10;
        //boolean flag to block processing any queued invoker
        var _blockingFlag = false;
        //timer for method call
        var _methodTimeoutTimer = null;
        //the processing interval for method timeout
        var _methodTimeoutProcessInterval = 2000;
        //method timeout in ms, this value should be larger than OMEX service extension timeout to get reliable failure telemetry
        var _methodTimeoutDefault = 65000;
        var _methodTimeout = _methodTimeoutDefault;
        var _serviceEndPoints = {};
        var _clientEndPoints = {};
        var _initialized = false;

        //private method to parse the messageObject received and find the controlId
        function _getControlIdFromMessageObject(messageObject) {
          if (!messageObject) return null;
          //get actionName for the message
          const actionName = messageObject._actionName;
          try {
            if (!actionName) throw new Error("actionName not found in messageObject");

            let controlId;
            switch (actionName) {
              case "executeMethod":
                controlId = messageObject._data.DdaMethod.ControlId;
                break;
              default:
                //avoid logging since we didn't parse the actionName
                return null;
            }

            if (typeof controlId !== "string") {
              throw new Error("Failed to extract controlId from messageObject");
            }
            return controlId;
          } catch (ex) {
            OsfMsAjaxFactory.msAjaxDebug.trace(
              `XdmCommunicationManager._getControlIdFromMessageObject (actionName: ${actionName}) error: ${ex.message}`,
            );
            return null;
          }
        }
        //private method to lookup service endpoint for the given conversation Id
        function _lookupServiceEndPoint(conversationId) {
          for (var id in _serviceEndPoints) {
            if (_serviceEndPoints[id]._conversations[conversationId]) {
              return _serviceEndPoints[id];
            }
          }
          OsfMsAjaxFactory.msAjaxDebug.trace("Unknown conversation Id.");
          throw OsfMsAjaxFactory.msAjaxError.argument("conversationId");
        }
        //private method to lookup client endpoint for the given conversation Id
        function _lookupClientEndPoint(conversationId) {
          var clientEndPoint = _clientEndPoints[conversationId];
          if (!clientEndPoint) {
            OsfMsAjaxFactory.msAjaxDebug.trace("Unknown conversation Id.");
          }
          return clientEndPoint;
        }
        //private method to lookup method object given the serviceEndpoint and message
        function _lookupMethodObject(serviceEndPoint, messageObject) {
          var methodOrEventMethodObject = serviceEndPoint._methodObjectList[messageObject._actionName];
          if (!methodOrEventMethodObject) {
            //the specified methodName is not a registered method
            OsfMsAjaxFactory.msAjaxDebug.trace(
              "The specified method is not registered on service endpoint:" + messageObject._actionName,
            );
            throw OsfMsAjaxFactory.msAjaxError.argument("messageObject");
          }
          var methodObject = null;
          if (messageObject._actionType === Microsoft.Office.Common.ActionType.invoke) {
            methodObject = methodOrEventMethodObject;
          } else if (messageObject._actionType === Microsoft.Office.Common.ActionType.registerEvent) {
            methodObject = methodOrEventMethodObject.getRegisterMethodObject();
          } else {
            methodObject = methodOrEventMethodObject.getUnregisterMethodObject();
          }
          return methodObject;
        }
        //private method to queue an invoker object into the invokerQueue
        function _enqueInvoker(invoker) {
          _invokerQueue.push(invoker);
        }
        // private method to deque and process invokerQueue
        // this method is a callback registered with setInterval. It runs in setInterval's
        // object(i.e. current window) context, therefore use closure to make accessible
        // Channel's properties and methods by this method.
        function _dequeInvoker() {
          if (_messageProcessingTimer !== null) {
            //process the invokerQueue
            //check the blockingflag before deque
            //TODO: what we do if the method called behaviour badly, never come back?
            if (OSF.OUtil.checkFlight(OSF.FlightTreatmentNames.ProcessMultipleCommandsInDequeInvoker)) {
              while (!_blockingFlag && _invokerQueue.length > 0) {
                //deque from invokerQueue
                var invoker = _invokerQueue.shift();
                _executeCommand(invoker);
              }

              if (_invokerQueue.length == 0) {
                clearInterval(_messageProcessingTimer);
                _messageProcessingTimer = null;
              }
            } else {
              if (!_blockingFlag) {
                //deque from invokerQueue
                if (_invokerQueue.length > 0) {
                  var invoker = _invokerQueue.shift();
                  _executeCommand(invoker);
                } else {
                  clearInterval(_messageProcessingTimer);
                  _messageProcessingTimer = null;
                }
              }
            }
          } else {
            OsfMsAjaxFactory.msAjaxDebug.trace("channel is not ready.");
          }
        }
        function _executeCommand(invoker) {
          //set the blockingFlag
          _blockingFlag = invoker.getInvokeBlockingFlag();
          //invoke the method. catch any invoking exception
          //inside of invoke, and send back to caller
          invoker.invoke();
          _lastMessageProcessTime = new Date().getTime();
        }
        // private method to check method call timeout
        function _checkMethodTimeout() {
          if (_methodTimeoutTimer) {
            var clientEndPoint;
            var methodCallsNotTimedout = 0;
            var now = new Date();
            var timeoutValue;
            for (var conversationId in _clientEndPoints) {
              clientEndPoint = _clientEndPoints[conversationId];
              for (var correlationId in clientEndPoint._callbackList) {
                var callbackEntry = clientEndPoint._callbackList[correlationId];
                //if timeout happens
                timeoutValue = callbackEntry.timeout ? callbackEntry.timeout : _methodTimeout;
                if (timeoutValue >= 0 && Math.abs(now.getTime() - callbackEntry.createdOn) >= timeoutValue) {
                  try {
                    if (callbackEntry.callback) {
                      callbackEntry.callback(
                        Microsoft.Office.Common.InvokeResultCode.errorHandlingMethodCallTimedout,
                        null,
                      );
                    }
                  } finally {
                    delete clientEndPoint._callbackList[correlationId];
                  }
                } else {
                  methodCallsNotTimedout++;
                }
              }
            }
            if (methodCallsNotTimedout === 0) {
              clearInterval(_methodTimeoutTimer);
              _methodTimeoutTimer = null;
            }
          } else {
            OsfMsAjaxFactory.msAjaxDebug.trace("channel is not ready.");
          }
        }
        //private method to clean up after calling invokeCompleteCallback is finished
        function _postCallbackHandler() {
          //unblock processing invokerQueue
          _blockingFlag = false;
        }
        //private method to register listener
        function _registerListener(listener) {
          if (window.addEventListener) {
            // IE version >= 11 and Other browsers
            window.addEventListener("message", listener);
          } else if (navigator.userAgent.indexOf("MSIE") > -1 && (window as any).attachEvent) {
            // IE version < 11
            (window as any).attachEvent("onmessage", listener);
          } else {
            OsfMsAjaxFactory.msAjaxDebug.trace("Browser doesn't support the required API.");
            throw OsfMsAjaxFactory.msAjaxError.argument("Browser");
          }
        }
        // this is to check if a url start with the same origin.
        // origin should be the leading part of url (indexOf result 0).
        function _checkOrigin(url, origin) {
          var res = false;
          if (!url || !origin || url === "null" || origin === "null" || !url.length || !origin.length) {
            return res;
          }
          const url_parser = OSF.OUtil.parseUrl(url, /*enforceHttps*/ true);
          const org_parser = OSF.OUtil.parseUrl(origin, /*enforceHttps*/ true);
          return _urlCompare(url_parser, org_parser);
        }
        // this is to check if origin is within the allowed domain list.
        // origin should be the leading part of url (indexOf result 0).
        function _checkOriginWithAppDomains(allowed_domains: string[], origin: string) {
          if (OSF.OUtil.isChangeGateEnabled("OfficeVSO:9323862_FixAllowDomainCheckWithoutProtocol")) {
            if (typeof origin !== "string" || origin === "null" || !Array.isArray(allowed_domains)) {
              return false;
            }
            const org_parser = OSF.OUtil.parseUrl(origin);
            return allowed_domains.some((domain) => {
              const urlForDomain = (domain.indexOf("://") !== -1 ? "" : "https://") + domain;
              return _urlCompare(org_parser, OSF.OUtil.parseUrl(urlForDomain));
            });
          } else {
            var res = false;
            if (
              !origin ||
              origin === "null" ||
              !origin.length ||
              !allowed_domains ||
              !(allowed_domains instanceof Array) ||
              !allowed_domains.length
            ) {
              return res;
            }
            const org_parser = OSF.OUtil.parseUrl(origin);
            return allowed_domains.some(
              (domain) => domain.indexOf("://") !== -1 && _urlCompare(org_parser, OSF.OUtil.parseUrl(domain)),
            );
          }
        }
        /**
         * _isHostNameValidWacDomain checks if the provided string is a valid WAC host domain.
         * Each valid domain must match one of the regular expressions in the regexHostNameStringArray array.
         * These regular expressions are then joined into one string as individual valid cases.
         * Any new WAC domains needs to be added to this list for support.
         * This function is needed since Excel Online downloads JS and other documents from different location to page
         * @param hostName The string containing the host name to be validated
         */
        function _isHostNameValidWacDomain(hostName: string): boolean {
          if (!hostName || hostName === "null") {
            return false;
          }
          var regexHostNameStringArray = new Array(
            "^office-int\\.com$",
            "^officeapps\\.live-int\\.com$",
            "^.*\\.dod\\.online\\.office365\\.us$",
            "^.*\\.gov\\.online\\.office365\\.us$",
            "^.*\\.officeapps\\.live\\.com$",
            "^.*\\.officeapps\\.live-int\\.com$",
            "^.*\\.officeapps-df\\.live\\.com$",
            "^.*\\.online\\.office\\.de$",
            "^.*\\.partner\\.officewebapps\\.cn$",
            "^.*\\.office\\.net$",
            "^" + document.domain.replace(new RegExp("\\.", "g"), "\\.") + "$",
          );
          var regexHostName = new RegExp(regexHostNameStringArray.join("|"));
          return regexHostName.test(hostName);
        }
        /**
         * Checks the if the origin of the postMessage is a subdomain of the sourceLocation. If an add-in specifies
         * https://domain.com as the sourceLocation, we allow the add-in to re-direct to https://subdomain.domain.com.
         * If the add-in specifies https://subdomain.domain.com, we will not allow redirection to https://domain.com.
         * @param sourceLocation specified by the manifes.
         * @param messageOrigin Origin which sent the post message to the host.
         * @returns True if the origin of the message has the same port, protocol, and has either the same hostname or is a subdomain of the sourceLocation.
         */
        function _isTargetSubdomainOfSourceLocation(sourceLocation: string, messageOrigin: string): boolean {
          if (!sourceLocation || !messageOrigin || sourceLocation === "null" || messageOrigin === "null") {
            return false;
          }
          const sourceLocationParser = OSF.OUtil.parseUrl(sourceLocation, /*enforceHttps*/ true);
          const messageOriginParser = OSF.OUtil.parseUrl(messageOrigin, /*enforceHttps*/ true);
          if (sourceLocationParser == null || messageOriginParser == null) {
            return false;
          }
          let isSameProtocol = sourceLocationParser.protocol === messageOriginParser.protocol;
          let isSamePort = sourceLocationParser.port === messageOriginParser.port;
          let originHostName = messageOriginParser.hostname;
          let sourceLocationHostName = sourceLocationParser.hostname;
          // Checking if host name is exactly equal.
          let isSameDomain = originHostName === sourceLocationHostName;
          let isSubDomain = false;
          if (!isSameDomain) {
            /*
             * If origin is a subdomain, it must have a '.' before the original url part.
             * For example, 'testsubdomain.domain.com' is not a subdomain of 'subdomain.domain.com', but 'test.subdomain.domain.com' is.
             */
            isSubDomain = sourceLocationHostName && originHostName.endsWith("." + sourceLocationHostName);
          }
          let isSameDomainOrSubdomain = isSameDomain || isSubDomain;
          return isSamePort && isSameProtocol && isSameDomainOrSubdomain;
        }
        // compare hostname, protocol and port of 2 urls
        function _urlCompare(url_parser1: URL, url_parser2: URL) {
          if (
            !url_parser1 ||
            !url_parser2 ||
            !url_parser1.protocol ||
            !url_parser2.protocol ||
            !url_parser1.hostname ||
            !url_parser2.hostname
          ) {
            return false;
          }

          return (
            url_parser1.hostname === url_parser2.hostname &&
            url_parser1.protocol === url_parser2.protocol &&
            url_parser1.port === url_parser2.port
          );
        }
        // private method to receive method call request message and response message
        // this method is a event handler registered with onmessage event. It runs in window's
        // context, so use closure to make Channel context available to the method, in another
        // word, to make accessible Channel's properties and methods by this method.
        function _receive(e) {
          if (!OSF) {
            // In Edge, when trying to close an agave, window.blur event will be triggered after osfcontrol, serviceendpoint and conversationid has been removed, then there are will be a Sys.ArgumentException return here,
            // But since the iframe has been closed, the context here has been lost, so just return to avoid scripterror since OSF is null; For now only close inline dialog will trigger.
            return;
          }
          if (e.data != "") {
            var messageObject;
            var serializedMessage = e.data;
            // See if message was serialized with Browser
            try {
              messageObject = Microsoft.Office.Common.MessagePackager.unenvelope(serializedMessage);
            } catch (ex) {
              return; //this is the message we cannot handle, just return to let other handler to handle it
            }
            //after deserialization, methods won't be available, so use properties directly
            if (messageObject._messageType === Microsoft.Office.Common.MessageType.request) {
              //this is a request, callee side call the method
              var requesterUrl = e.origin == null || e.origin === "null" ? messageObject._origin : e.origin; //work around, when html5 sandbox is enabled for chrome, e.origin returns "null"
              try {
                var serviceEndPoint = _lookupServiceEndPoint(messageObject._conversationId);
                var conversation = serviceEndPoint._conversations[messageObject._conversationId];
                var allowedDomains = [conversation.url].concat(
                  serviceEndPoint._appDomains[messageObject._conversationId],
                );
                if (!_checkOriginWithAppDomains(allowedDomains, e.origin)) {
                  if (
                    !OfficeExt.appSpecificCheckOrigin(
                      allowedDomains,
                      e,
                      messageObject._origin,
                      _checkOriginWithAppDomains,
                    )
                  ) {
                    let isOriginSubdomain = _isTargetSubdomainOfSourceLocation(conversation.url, e.origin);
                    if (!isOriginSubdomain) {
                      throw "Failed origin check";
                    }
                  }
                }
                // This is needed for GetAccessToken API to match the domain making the request with the resource
                var dataWithOrigin = messageObject._data != null ? messageObject._data : {};
                if (typeof dataWithOrigin == "object") {
                  dataWithOrigin.SecurityOrigin = e.origin;
                }

                var trustedParams = {
                  controlId: conversation.controlId,
                  securityOrigin: e.origin,
                };
                var policyManager = serviceEndPoint.getPolicyManager();
                if (
                  policyManager &&
                  !policyManager.checkPermission(
                    messageObject._conversationId,
                    messageObject._actionName,
                    dataWithOrigin,
                  )
                ) {
                  throw "Access Denied";
                }
                var controlIdTrusted = conversation.controlId;
                if (controlIdTrusted) {
                  //depending on each actionName/API, we need to parse messageObject to find the controlId
                  var controlIdToVerify = _getControlIdFromMessageObject(messageObject);
                  if (controlIdToVerify && controlIdToVerify !== controlIdTrusted) {
                    throw "Access Denied";
                  }
                }

                var methodObject = _lookupMethodObject(serviceEndPoint, messageObject);
                //create invokeCompleteCallback object
                var invokeCompleteCallback = new Microsoft.Office.Common.InvokeCompleteCallback(
                  e.source,
                  requesterUrl,
                  messageObject._actionName,
                  messageObject._conversationId,
                  messageObject._correlationId,
                  _postCallbackHandler,
                );
                //create invoker
                var invoker = new Microsoft.Office.Common.Invoker(
                  methodObject,
                  dataWithOrigin,
                  invokeCompleteCallback,
                  serviceEndPoint._eventHandlerProxyList,
                  messageObject._conversationId,
                  messageObject._actionName,
                  trustedParams,
                );
                var shouldEnque = true;
                //start the timer if needed
                if (_messageProcessingTimer == null) {
                  if (
                    (_lastMessageProcessTime == null ||
                      new Date().getTime() - _lastMessageProcessTime > _processInterval) &&
                    !_blockingFlag
                  ) {
                    _executeCommand(invoker);
                    shouldEnque = false;
                  } else {
                    _messageProcessingTimer = setInterval(_dequeInvoker, _processInterval);
                  }
                }
                if (shouldEnque) {
                  //queue invoker
                  _enqueInvoker(invoker);
                }
              } catch (ex) {
                if (serviceEndPoint && serviceEndPoint._onHandleRequestError) {
                  serviceEndPoint._onHandleRequestError(messageObject, ex);
                }
                //TODO, what to do if exception is thrown here by envelope()
                //construct a response object
                var errorCode = Microsoft.Office.Common.InvokeResultCode.errorHandlingRequest;
                if (ex == "Access Denied") {
                  errorCode = Microsoft.Office.Common.InvokeResultCode.errorHandlingRequestAccessDenied;
                }
                var callResponse = new Microsoft.Office.Common.Response(
                  messageObject._actionName,
                  messageObject._conversationId,
                  messageObject._correlationId,
                  errorCode,
                  Microsoft.Office.Common.ResponseType.forCalling,
                  ex,
                );
                var envelopedResult = Microsoft.Office.Common.MessagePackager.envelope(callResponse);
                // trying to get e.source.postMessage can throw rather than just returning null/undefined in Edge
                var canPostMessage = false;
                try {
                  canPostMessage = !!(e.source && e.source.postMessage);
                } catch (ex) {}
                // Enforce "Same-origin" policy for postMessage. See security vulnerability in MSRC Case: 51258
                var isOriginValid = false;
                if (
                  window.location.href &&
                  e.origin &&
                  e.origin !== "null" &&
                  _isTargetSubdomainOfSourceLocation(window.location.href, e.origin)
                ) {
                  isOriginValid = true;
                } else {
                  if (e.origin && e.origin !== "null") {
                    // Need this because Excel Online is on different hostname to iFramed content
                    const hostname = OSF.OUtil.parseUrl(e.origin, /*enforceHttps*/ true).hostname;
                    isOriginValid = _isHostNameValidWacDomain(hostname);
                  }
                }
                if (canPostMessage && isOriginValid) {
                  e.source.postMessage(envelopedResult, requesterUrl);
                }
              }
            } else if (messageObject._messageType === Microsoft.Office.Common.MessageType.response) {
              //this is a response
              var clientEndPoint = _lookupClientEndPoint(messageObject._conversationId);
              if (!clientEndPoint) {
                return;
              }
              if (!_checkOrigin(clientEndPoint._targetUrl, e.origin)) {
                throw "Failed orgin check";
              }
              if (messageObject._responseType === Microsoft.Office.Common.ResponseType.forCalling) {
                // this is a response for a calling
                //The caller side calls caller's callback
                var callbackEntry = clientEndPoint._callbackList[messageObject._correlationId];
                if (callbackEntry) {
                  try {
                    if (callbackEntry.callback) callbackEntry.callback(messageObject._errorCode, messageObject._data);
                  } finally {
                    delete clientEndPoint._callbackList[messageObject._correlationId];
                  }
                }
              } else {
                //This is a response for an eventing (event raised)
                //The caller side invokes caller's eventHandler
                var eventhandler = clientEndPoint._eventHandlerList[messageObject._actionName];
                if (eventhandler !== undefined && eventhandler !== null) {
                  eventhandler(messageObject._data);
                }
              }
            } else {
              // this is not a valid message
              return;
            }
          }
        }
        //private method to initialize listener
        function _initialize() {
          if (!_initialized) {
            //register listener
            _registerListener(_receive);
            _initialized = true;
          }
        }
        // all public methods
        // Explanation: use closure to hide the private members and methods;
        // use an anonymous function to return an object which has all
        // the public methods; this makes the Singleton implementation.
        return {
          /// <summary>
          /// connect – start a new clientEndPoint.
          /// </summary>
          /// <param name="conversationId">The conversation Id. Must be provided</param>
          /// <param name="targetWindow">The window object of callee. Must be provided </param>
          /// <param name="targetUrl">The url of callee window. Must be provided </param>
          /// <accessibility>public</accessibility>
          connect: function Microsoft_Office_Common_XdmCommunicationManager$connect(
            conversationId,
            targetWindow,
            targetUrl,
          ) {
            var clientEndPoint = _clientEndPoints[conversationId];
            if (!clientEndPoint) {
              _initialize();
              clientEndPoint = new Microsoft.Office.Common.ClientEndPoint(conversationId, targetWindow, targetUrl);
              _clientEndPoints[conversationId] = clientEndPoint;
            }
            return clientEndPoint;
          },
          /// <summary>
          /// return the client endpoint for a given conversation Id
          /// </summary>
          /// <param name="conversationId">The conversation Id. Must be provided</param>
          /// <accessibility>public</accessibility>
          getClientEndPoint: function Microsoft_Office_Common_XdmCommunicationManager$getClientEndPoint(
            conversationId,
          ) {
            var e = Function._validateParams(arguments, [{ name: "conversationId", type: String, mayBeNull: false }]);
            if (e) throw e;
            return _clientEndPoints[conversationId];
          },
          /// <summary>
          /// create a service endpoint for others to consume (exposing methods and events)
          /// </summary>
          /// <param name="serviceEndPointId">An Id that uniquely identities this service endpoint. Must be provided</param>
          /// <accessibility>public</accessibility>
          createServiceEndPoint: function Microsoft_Office_Common_XdmCommunicationManager$createServiceEndPoint(
            serviceEndPointId,
          ) {
            _initialize();
            var serviceEndPoint = new Microsoft.Office.Common.ServiceEndPoint(serviceEndPointId);
            _serviceEndPoints[serviceEndPointId] = serviceEndPoint;
            return serviceEndPoint;
          },
          /// <summary>
          /// return the service endpoint for a given service endpoint Id.
          /// </summary>
          /// <param name="serviceEndPointId">The service endpoint Id. Must be provided</param>
          /// <accessibility>public</accessibility>
          getServiceEndPoint: function Microsoft_Office_Common_XdmCommunicationManager$getServiceEndPoint(
            serviceEndPointId,
          ) {
            var e = Function._validateParams(arguments, [
              { name: "serviceEndPointId", type: String, mayBeNull: false },
            ]);
            if (e) throw e;
            return _serviceEndPoints[serviceEndPointId];
          },
          /// <summary>
          /// delete the client endpoint for a given conversation Id
          /// </summary>
          /// <param name="conversationId">The conversation Id. Must be provided</param>
          /// <accessibility>public</accessibility>
          deleteClientEndPoint: function Microsoft_Office_Common_XdmCommunicationManager$deleteClientEndPoint(
            conversationId,
          ) {
            var e = Function._validateParams(arguments, [{ name: "conversationId", type: String, mayBeNull: false }]);
            if (e) throw e;
            delete _clientEndPoints[conversationId];
          },
          /// <summary>
          /// delete the service endpoint for a given serviceEndPointId
          /// </summary>
          /// <param name="serviceEndPointId">The serviceEndPointId. Must be provided</param>
          /// <accessibility>public</accessibility>
          deleteServiceEndPoint: function Microsoft_Office_Common_XdmCommunicationManager$deleteServiceEndPoint(
            serviceEndPointId,
          ) {
            var e = Function._validateParams(arguments, [
              { name: "serviceEndPointId", type: String, mayBeNull: false },
            ]);
            if (e) throw e;
            delete _serviceEndPoints[serviceEndPointId];
          },
          /// <summary>
          /// check whether a url is in app domains list.
          /// </summary>
          /// <accessibility>public</accessibility>
          urlCompare: function Microsoft_Office_Common_XdmCommunicationManager$_urlCompare(url_parser1, url_parser2) {
            return _urlCompare(url_parser1, url_parser2);
          },
          /// <summary>
          /// check whether a url is in app domains list.
          /// </summary>
          /// <accessibility>public</accessibility>
          checkUrlWithAppDomains: function Microsoft_Office_Common_XdmCommunicationManager$_checkUrlWithAppDomains(
            appDomains,
            origin,
          ) {
            return _checkOriginWithAppDomains(appDomains, origin);
          },
          /// <summary>
          /// check whether a url is subdomain of source location
          /// </summary>
          /// <accessibility>public</accessibility>
          isTargetSubdomainOfSourceLocation:
            function Microsoft_Office_Common_XdmCommunicationManager$_isTargetSubdomainOfSourceLocation(
              sourceLocation,
              messageOrigin,
            ) {
              return _isTargetSubdomainOfSourceLocation(sourceLocation, messageOrigin);
            },
          /// <summary>
          /// set method timeout (in ms).
          /// </summary>
          /// <param name="methodTimeout">method timeout in ms. Must be provided</param>
          /// <accessibility>private</accessibility>
          _setMethodTimeout: function Microsoft_Office_Common_XdmCommunicationManager$_setMethodTimeout(methodTimeout) {
            var e = Function._validateParams(arguments, [{ name: "methodTimeout", type: Number, mayBeNull: false }]);
            if (e) throw e;
            _methodTimeout = methodTimeout <= 0 ? _methodTimeoutDefault : methodTimeout;
          },
          /// <summary>
          /// start method call timer for timeout check if needed.
          /// </summary>
          /// <accessibility>private</accessibility>
          _startMethodTimeoutTimer:
            function Microsoft_Office_Common_XdmCommunicationManager$_startMethodTimeoutTimer() {
              //start the timer if needed
              if (!_methodTimeoutTimer) {
                _methodTimeoutTimer = setInterval(_checkMethodTimeout, _methodTimeoutProcessInterval);
              }
            },
          /// <summary>
          /// check whether hostName is a valid WAC domain
          /// </summary>
          /// <accessibility>public</accessibility>
          isHostNameValidWacDomain: function Microsoft_Office_Common_XdmCommunicationManager$_isHostNameValidWacDomain(
            hostName: string,
          ): boolean {
            return _isHostNameValidWacDomain(hostName);
          },
          /// <summary>
          /// check whether two urls that have been parsed have the same ports (directly or indirectly via using the same protocol and the port field is empty)
          /// </summary>
          /// <accessibility>private</accessibility>
          _hasSamePort: function Microsoft_Office_Common_XdmCommunicationManager$_hasSamePort(
            url_parser1: URL,
            url_parser2: URL,
          ): boolean {
            return url_parser1.port == url_parser2.port;
          },
          /// <summary>
          /// Pass the message to the _receive function for processing.
          /// </summary>
          /// <accessibility>public</accessibility>
          receiveFromClient: function Microsoft_Office_Common_XdmCommunicationManager$_receiveFromClient(e) {
            _receive(e);
          },
        };
      })();

      /// <summary>
      /// MethodObject – contains information about a method to be invoked
      /// </summary>
      /// <accessibility>private</accessibility>
      export class MethodObject {
        _blockingOthers: any;
        _invokeType: any;
        _method: any;
        constructor(method, invokeType, blockingOthers) {
          //function object for the method to be invoked
          this._method = method;
          //method invocation type
          this._invokeType = invokeType;
          //the flag specifying if invocation of this method should block others
          //until this invocation is finished
          this._blockingOthers = blockingOthers;
        }
        getMethod() {
          return this._method;
        }
        getInvokeType() {
          return this._invokeType;
        }
        getBlockingFlag() {
          return this._blockingOthers;
        }
      }

      /// <summary>
      /// EventMethodObject – contains information about register and unregister methods for an event
      /// </summary>
      /// <accessibility>private</accessibility>
      export class EventMethodObject {
        _registerMethodObject: any;
        _unregisterMethodObject: any;
        constructor(registerMethodObject, unregisterMethodObject) {
          //register event method object
          this._registerMethodObject = registerMethodObject;
          //unregister event method object
          this._unregisterMethodObject = unregisterMethodObject;
        }
        getRegisterMethodObject() {
          return this._registerMethodObject;
        }
        getUnregisterMethodObject() {
          return this._unregisterMethodObject;
        }
      }

      /// <summary>
      /// ServiceEndPoint – expose methods and events
      /// </summary>
      /// <param name="serviceEndPointId">An Id that uniquely identities this service endpoint. Must be provided</param>
      /// <accessibility>public</accessibility>
      export class ServiceEndPoint {
        _Id: any;
        _appDomains: any;
        _conversations: any;
        _eventHandlerProxyList: any;
        _methodObjectList: any;
        _onHandleRequestError: any;
        _policyManager: any;
        constructor(serviceEndPointId) {
          var e = Function._validateParams(arguments, [{ name: "serviceEndPointId", type: String, mayBeNull: false }]);
          if (e) throw e;
          //object, contains a list of MethodObject or EventMethodObject; The key is method Name
          //or event Name
          this._methodObjectList = {};
          //object, contains references to the event handler function, registered with the event.
          //The key is conversationId + event Name
          this._eventHandlerProxyList = {};
          //service endpoint ID, which uniquely identitfies a service endpoint
          this._Id = serviceEndPointId;
          //all conversation IDs registered on this service endpoint
          this._conversations = {};
          //policy manager
          this._policyManager = null;
          //allowed domains for access
          this._appDomains = {};
          //handle request onError function
          this._onHandleRequestError = null;
        }

        /// <summary>
        /// registerMethod – add a method to callee which can been called by a caller.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="methodName">string, method name</param>
        /// <param name="method">function, method itself</param>
        /// <param name="invokeType">InvokeType, type of invocation for the method to be invoked</param>
        /// <param name="blockingOthers">boolean, flag to indicate if this method invocation is to be sequnetial,
        ///                              in another word, if this method is going to blocking others until itself
        ///                              is finished</param>
        registerMethod(methodName, method, invokeType, blockingOthers) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "methodName", type: String, mayBeNull: false },
            { name: "method", type: Function, mayBeNull: false },
            { name: "invokeType", type: Number, mayBeNull: false },
            { name: "blockingOthers", type: Boolean, mayBeNull: false },
          ]);
          if (e) throw e;
          if (
            invokeType !== Microsoft.Office.Common.InvokeType.async &&
            invokeType !== Microsoft.Office.Common.InvokeType.sync
          ) {
            throw OsfMsAjaxFactory.msAjaxError.argument("invokeType");
          }
          var methodObject = new Microsoft.Office.Common.MethodObject(method, invokeType, blockingOthers);
          this._methodObjectList[methodName] = methodObject;
        }

        /// <summary>
        /// unregisterMethod – remove a method from callee.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="methodName">the method name for the method to be removed</param>
        unregisterMethod(methodName) {
          //check parameters
          var e = Function._validateParams(arguments, [{ name: "methodName", type: String, mayBeNull: false }]);
          if (e) throw e;
          delete this._methodObjectList[methodName];
        }

        /// <summary>
        /// registerEvent – add event name, register and unregister methods to callee which can been registered or
        ///                 unregistered for an event by a caller.
        //                  Note, regiser/registerMethod will be sync-invoked with this function.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="eventName">string, event name</param>
        /// <param name="registerMethod">function, method to register for the specified event</param>
        /// <param name="unregisterMethod">function, method to unregister for the specified event</param>
        registerEvent(eventName, registerMethod, unregisterMethod) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "eventName", type: String, mayBeNull: false },
            { name: "registerMethod", type: Function, mayBeNull: false },
            { name: "unregisterMethod", type: Function, mayBeNull: false },
          ]);
          if (e) throw e;
          var methodObject = new Microsoft.Office.Common.EventMethodObject(
            new Microsoft.Office.Common.MethodObject(
              registerMethod,
              Microsoft.Office.Common.InvokeType.syncRegisterEvent,
              false,
            ),
            new Microsoft.Office.Common.MethodObject(
              unregisterMethod,
              Microsoft.Office.Common.InvokeType.syncUnregisterEvent,
              false,
            ),
          );
          this._methodObjectList[eventName] = methodObject;
        }

        /// <summary>
        /// registerEventEx – add event name, register and unregister methods to callee which can been registered or
        ///                 unregistered for an event by a caller.
        //                  Note, regisermethod/unregisterMethod will be invoked with the specifed invokeType in this function.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="eventName">string, event name</param>
        /// <param name="registerMethod">function, method to register for the specified event</param>
        /// <param name="registerMethodInvokeType">the invokeType for the registerMethod</param>
        /// <param name="unregisterMethod">function, method to unregister for the specified event</param>
        /// <param name="unregisterMethodInvokeType">the invokeType for the unregisterMethod</param>
        registerEventEx(
          eventName,
          registerMethod,
          registerMethodInvokeType,
          unregisterMethod,
          unregisterMethodInvokeType,
        ) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "eventName", type: String, mayBeNull: false },
            { name: "registerMethod", type: Function, mayBeNull: false },
            { name: "registerMethodInvokeType", type: Number, mayBeNull: false },
            { name: "unregisterMethod", type: Function, mayBeNull: false },
            { name: "unregisterMethodInvokeType", type: Number, mayBeNull: false },
          ]);
          if (e) throw e;
          var methodObject = new Microsoft.Office.Common.EventMethodObject(
            new Microsoft.Office.Common.MethodObject(registerMethod, registerMethodInvokeType, false),
            new Microsoft.Office.Common.MethodObject(unregisterMethod, unregisterMethodInvokeType, false),
          );
          this._methodObjectList[eventName] = methodObject;
        }

        //public method to unregister an event and event methods with the receiver
        unregisterEvent(eventName) {
          //check parameters
          var e = Function._validateParams(arguments, [{ name: "eventName", type: String, mayBeNull: false }]);
          if (e) throw e;
          this.unregisterMethod(eventName);
        }

        /// <summary>
        /// register conversation Id on this service endpoint before client can connect using this conversation Id.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="conversationId">conversation Id</param>
        /// <param name="conversationUrl">conversation frame URL for keeping track of origin check</param>
        /// <param name="appDomains">allowed domains for access</param>
        /// <param name="controlId">trusted control Id</param>
        registerConversation(conversationId, conversationUrl, appDomains?, controlId?) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "conversationId", type: String, mayBeNull: false },
            { name: "conversationUrl", type: String, mayBeNull: false, optional: true },
            { name: "appDomains", type: Object, mayBeNull: true, optional: true },
            { name: "controlId", type: String, mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          if (appDomains) {
            //check appDomains is a valid Array
            if (!(appDomains instanceof Array)) {
              throw OsfMsAjaxFactory.msAjaxError.argument("appDomains");
            }
            this._appDomains[conversationId] = appDomains;
          }
          this._conversations[conversationId] = { url: conversationUrl, controlId: controlId };
        }

        /// <summary>
        /// unregister conversation Id on this service endpoint.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="conversationId">conversation Id</param>
        unregisterConversation(conversationId) {
          //check parameters
          var e = Function._validateParams(arguments, [{ name: "conversationId", type: String, mayBeNull: false }]);
          if (e) throw e;
          delete this._conversations[conversationId];
        }

        /// <summary>
        /// set the policy manager for this service endpoint.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="policyManager">policy Manager</param>
        setPolicyManager(policyManager) {
          //check parameters
          var e = Function._validateParams(arguments, [{ name: "policyManager", type: Object, mayBeNull: false }]);
          if (e) throw e;
          //check targetWindow is valid
          if (!policyManager.checkPermission) {
            throw OsfMsAjaxFactory.msAjaxError.argument("policyManager");
          }
          this._policyManager = policyManager;
        }

        /// <summary>
        /// return the policy mananger for this service endpoint.
        /// </summary>
        /// <accessibility>public</accessibility>
        getPolicyManager() {
          return this._policyManager;
        }

        //public method to release the objects references that ServiceEndPoint holds
        dispose() {
          this._methodObjectList = null;
          this._eventHandlerProxyList = null;
          this._Id = null;
          this._conversations = null;
          this._policyManager = null;
          this._appDomains = null;
          this._onHandleRequestError = null;
        }
      }

      /// <summary>
      /// ClientEndPoint– contains sender's data structures and logoics
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <param name="conversationId">The conversation Id. Must be provided</param>
      /// <param name="targetWindow">The window object of callee. Must be provided </param>
      /// <param name="targetUrl">The url of callee window. Must be provided </param>
      export class ClientEndPoint {
        _callbackList: any;
        _callingIndex: any;
        _checkReceiverOriginAndRun: any;
        _checkStatusLogged: any;
        _conversationId: any;
        _eventHandlerList: any;
        _hostTrustCheckStatus: any;
        _targetUrl: any;
        _targetWindow: any;
        constructor(conversationId, targetWindow, targetUrl) {
          var e = Function._validateParams(arguments, [
            { name: "conversationId", type: String, mayBeNull: false },
            { name: "targetWindow", mayBeNull: false },
            { name: "targetUrl", type: String, mayBeNull: false },
          ]);
          if (e) throw e;
          //check targetWindow is valid
          try {
            // when targetWindow is window.opener, then edge will throw 'argument not optional' exception, so add specific handle for edge in catch
            if (!targetWindow.postMessage) {
              throw OsfMsAjaxFactory.msAjaxError.argument("targetWindow");
            }
          } catch (ex) {
            // check whether targetWindow has postMessage property
            if (!Object.prototype.hasOwnProperty.call(targetWindow, "postMessage")) {
              throw OsfMsAjaxFactory.msAjaxError.argument("targetWindow");
            }
          }
          //conversation Id
          this._conversationId = conversationId;
          //target window
          this._targetWindow = targetWindow;
          //target window url
          this._targetUrl = targetUrl;
          //calling index used by caller
          this._callingIndex = 0;
          //object, contains references to calller's callback function, each ref will be removed
          //after each invocation. The key is callingIndex/correlationId
          this._callbackList = {};
          //object, contains references to caller's event handler function, each ref won't be
          //removed until unregisterEvent is called. The key is event name
          this._eventHandlerList = {};
          //function to check if receiver(WAC) origin is not trusted AND then runs passed in delegate
          this._checkReceiverOriginAndRun = null;
          //flag indicate the receiver(WAC) origin is not trusted
          this._hostTrustCheckStatus = Microsoft.Office.Common.HostTrustStatus.unknown;
          //flag indicate if the trust check status is logged
          this._checkStatusLogged = false;
        }

        /// <summary>
        /// invoke – invoke a method on the specified targeted callee from caller.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="targetMethodName">The method name for the method to be called</param>
        /// <param name="callback">The callback fuction to be called when invocation is finished. This is where caller
        ///                        can expect and handle the result. First param is the call status; Second param
        ///                        value is the result</param>
        /// <param name="params">The parameter values for the call. Pass in null if no params. Special property __timeout__ can be used for per method call timeout (ms) setting.</param>
        /// <param name="trustedParams">The trusted parameetrs for this call.</param>
        /// <remarks>All the paremters must be provided. use null for the value if it is not needed. For example,
        ///          if there is no need to know call result and handle the result, use null for callback</remarks>
        invoke(targetMethodName, callback, param, trustedParams = null) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "targetMethodName", type: String, mayBeNull: false },
            { name: "callback", type: Function, mayBeNull: true },
            { name: "param", mayBeNull: true },
            { name: "trustedParams", mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          var me = this;
          var funcToRun = function () {
            //create a correlationId for this calling instance
            var correlationId = me._callingIndex++;
            //add callback to callbackList
            var now = new Date();
            var callbackEntry: any = { callback: callback, createdOn: now.getTime() };
            //allow each invoke to set its own timeout through __timeout__ property
            if (param && typeof param === "object" && typeof param.__timeout__ === "number") {
              callbackEntry.timeout = param.__timeout__;
              delete param.__timeout__;
            }
            me._callbackList[correlationId] = callbackEntry;
            try {
              if (me._hostTrustCheckStatus !== Microsoft.Office.Common.HostTrustStatus.trusted) {
                if (targetMethodName !== "ContextActivationManager_getAppContextAsync") {
                  throw "Access Denied";
                }
              }
              //construct a request object
              var callRequest = new Microsoft.Office.Common.Request(
                targetMethodName,
                Microsoft.Office.Common.ActionType.invoke,
                me._conversationId,
                correlationId,
                param,
              );
              //serialize the request object
              var msg = Microsoft.Office.Common.MessagePackager.envelope(callRequest);
              me._targetWindow.postMessage(msg, me._targetUrl);
              Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
            } catch (ex) {
              try {
                if (callback !== null)
                  //send the exception back to the caller
                  callback(Microsoft.Office.Common.InvokeResultCode.errorInRequest, ex);
              } finally {
                delete me._callbackList[correlationId];
              }
            }
          };
          if (me._checkReceiverOriginAndRun) {
            me._checkReceiverOriginAndRun(funcToRun);
          } else {
            me._hostTrustCheckStatus = Microsoft.Office.Common.HostTrustStatus.trusted; // default to trusted when the method is not defined
            funcToRun();
          }
        }

        /// <summary>
        /// registerForEvent – registers for an event method on the specified targeted callee from caller.The event method
        ///                    must have been added to the callee by using registerEvent.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="targetEventName">The event name for the event to be registered</param>
        /// <param name="eventHandler">The callback fuction to be called when the specified event is finished. This is
        ///                        where caller can expect and handle the result of eventing operation. First param is
        ///                        the event data passing status; Second param value is the event data</param>
        /// <param name="callback">The callback fuction to be called when registering event is finished. This is where
        ///                        caller can expect and handle the result of registering operation, to know if the
        ///                        registration is sucessful or not, First param is the call status; Second param value
        ///                        is the result</param>
        /// <param name="data">The paremeters for register event method on the caller.</param>
        /// <remarks>All the paremters must be provided, except for the parameter "params". use null for the value if
        ///          it is not needed. For example, if there is no need to know call result and handle the result, use
        ///          null for callback</remarks>
        registerForEvent(targetEventName, eventHandler, callback, data) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "targetEventName", type: String, mayBeNull: false },
            { name: "eventHandler", type: Function, mayBeNull: false },
            { name: "callback", type: Function, mayBeNull: true },
            { name: "data", mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          //create a correlationId for this calling instance
          var correlationId = this._callingIndex++;
          //add callback to callbackList
          var now = new Date();
          this._callbackList[correlationId] = { callback: callback, createdOn: now.getTime() };
          try {
            //construct a request object
            var callRequest = new Microsoft.Office.Common.Request(
              targetEventName,
              Microsoft.Office.Common.ActionType.registerEvent,
              this._conversationId,
              correlationId,
              data,
            );
            //serialize the request object
            var msg = Microsoft.Office.Common.MessagePackager.envelope(callRequest);
            this._targetWindow.postMessage(msg, this._targetUrl);
            Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
            //add eventHanlder to eventCallbackList if it succeeds until here
            this._eventHandlerList[targetEventName] = eventHandler;
          } catch (ex) {
            try {
              if (callback !== null) {
                //send the exception back to the caller
                callback(Microsoft.Office.Common.InvokeResultCode.errorInRequest, ex);
              }
            } finally {
              delete this._callbackList[correlationId];
            }
          }
        }

        /// <summary>
        /// unregisterForEvent – unregisters for an event on the specified targeted callee from caller.The event methods
        ///                      must have been added to the callee by using registerEvent.
        /// </summary>
        /// <accessibility>public</accessibility>
        /// <param name="targetEventName">The event name of the event to be unregistered</param>
        /// <param name="callback">The callback fuction to be called when unregistering event is finished. This is where
        ///                        caller can expect and handle the result of unregistering operation, to know if the
        ///                        unregistration is sucessful or not, First param is the call status; Second param value
        ///                        is the result</param>
        /// <param name="data">The paremeters for register event method on the caller.</param>
        /// <remarks>All the paremters must be provided, except for the parameter "params". use null for the value if it is
        ///          not needed. For example, if there is no need to know call result and handle the result, use null for
        ///          callback</remarks>
        unregisterForEvent(targetEventName, callback, data) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "targetEventName", type: String, mayBeNull: false },
            { name: "callback", type: Function, mayBeNull: true },
            { name: "data", mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          //create a correlationId for this calling instance
          var correlationId = this._callingIndex++;
          //add callback to callbackList
          var now = new Date();
          this._callbackList[correlationId] = { callback: callback, createdOn: now.getTime() };
          try {
            //construct a request object
            var callRequest = new Microsoft.Office.Common.Request(
              targetEventName,
              Microsoft.Office.Common.ActionType.unregisterEvent,
              this._conversationId,
              correlationId,
              data,
            );
            //serialize the request object
            var msg = Microsoft.Office.Common.MessagePackager.envelope(callRequest);
            this._targetWindow.postMessage(msg, this._targetUrl);
            Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
          } catch (ex) {
            try {
              if (callback !== null) {
                //send the exception back to the caller
                callback(Microsoft.Office.Common.InvokeResultCode.errorInRequest, ex);
              }
            } finally {
              delete this._callbackList[correlationId];
            }
          } finally {
            //try to unregister as much as we can even if it fails on callee side
            delete this._eventHandlerList[targetEventName];
          }
        }
      }

      /// <summary>
      /// Message – the base class of Request and Response message, contains request/response's envelope and data infomration.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="messageType">contains message type value</param>
      /// <param name="actionName">contains method name to be called or event name to be registered/unregistered</param>
      /// <param name="conversationId">unique id to identify the message sender</param>
      /// <param name="correlationId">unique id to identify current calling instance</param>
      /// <param name="data">optional, parameter values or result value for current calling instance</param>
      export class Message {
        _actionName: any;
        _conversationId: any;
        _correlationId: any;
        _data: any;
        _messageType: any;
        _origin: any;
        constructor(messageType, actionName, conversationId, correlationId, data) {
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "messageType", type: Number, mayBeNull: false },
            { name: "actionName", type: String, mayBeNull: false },
            { name: "conversationId", type: String, mayBeNull: false },
            { name: "correlationId", mayBeNull: false },
            { name: "data", mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          //message type
          this._messageType = messageType;
          //method name to be called or event name to be registered/unregistered
          this._actionName = actionName;
          //unique id to identify caller
          this._conversationId = conversationId;
          //unique id to identify current calling instance
          this._correlationId = correlationId;
          //origin Url. When HTML5 sandbox attribute is enabled for Chrome IFrame, e.origin has "null" value, so pass along the origin
          //in message for callback and events.
          this._origin = window.location.origin;
          //parameter values or result for current calling instance
          if (typeof data == "undefined") {
            this._data = null;
          } else {
            this._data = data;
          }
        }
        getActionName() {
          return this._actionName;
        }
        getConversationId() {
          return this._conversationId;
        }
        getCorrelationId() {
          return this._correlationId;
        }
        getOrigin() {
          return this._origin;
        }
        getData() {
          return this._data;
        }
        getMessageType() {
          return this._messageType;
        }
      }

      /// <summary>
      /// Request – contains calling request's envelope and data infomration.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="actionName">contains method or event name to be called</param>
      /// <param name="actionType">type of action to be perfomred on the specified action</param>
      /// <param name="conversationId">unique id to identify caller</param>
      /// <param name="correlationId">unique id to identify current calling instance</param>
      /// <param name="data">optional, parameter values for current calling instance</param>
      export class Request extends Message {
        static uber: any;
        _actionType: any;
        constructor(actionName, actionType, conversationId, correlationId, data) {
          super(Microsoft.Office.Common.MessageType.request, actionName, conversationId, correlationId, data);
          this._actionType = actionType;
        }
        getActionType() {
          return this._actionType;
        }
      }

      /// <summary>
      /// Response – contains calling response's envelope and data infomration.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="actionName">contains method name to be called</param>
      /// <param name="conversationId">unique id to identify caller</param>
      /// <param name="correlationId">unique id to identify current calling instance</param>
      /// <param name="errorCode">error code to indicate if there is and what is the error of current call;
      ///                         0 indicates ok, a negative number indicates an error</param>
      /// <param name="responseType">response type value for the response</param>
      /// <param name="data">optional, parameter values for current calling instance</param>
      export class Response extends Message {
        static uber: any;
        _errorCode: any;
        _responseType: any;
        constructor(actionName, conversationId, correlationId, errorCode, responseType, data) {
          super(Microsoft.Office.Common.MessageType.response, actionName, conversationId, correlationId, data);
          this._errorCode = errorCode;
          this._responseType = responseType;
        }
        getErrorCode() {
          return this._errorCode;
        }
        getResponseType() {
          return this._responseType;
        }
      }

      /// <summary>
      /// Invoker – contains information and a method of invoking per invocation instance. This is the class who
      ///           knows how to invoke the targeted method, and to invoke any post inovation operations.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="methodObject">contains the information about the method </param>
      /// <param name="paramValues">parameter values for the invocation instance</param>
      /// <param name="invokeCompleteCallback">contains the callback method once invocation is finished. This function has
      ///                                      the context information of sender/requester</param>
      /// <param name="eventHandlerProxyList">contains the list of eventHandlerProxy object on the callee's channel</param>
      /// <param name="conversationId">contains the conversationId</param>
      /// <param name="actionName">contains the actionName (eventName) for register/unregister event method invocation</param>
      export class Invoker {
        _callerId: any;
        _conversationId: any;
        _eventHandlerProxyList: any;
        _eventName: any;
        _invokeCompleteCallback: any;
        _methodObject: any;
        _param: any;
        _trustedParams: any;
        constructor(
          methodObject,
          paramValue,
          invokeCompleteCallback,
          eventHandlerProxyList,
          conversationId,
          eventName,
          trustedParams = null,
        ) {
          //TODO: move eventHandlerProxyList can be null, should move it to the end
          //check parameters
          var e = Function._validateParams(arguments, [
            { name: "methodObject", mayBeNull: false },
            { name: "paramValue", mayBeNull: true },
            { name: "invokeCompleteCallback", mayBeNull: false },
            { name: "eventHandlerProxyList", mayBeNull: true },
            { name: "conversationId", type: String, mayBeNull: false },
            { name: "eventName", type: String, mayBeNull: false },
            { name: "trustedParams", type: Object, mayBeNull: true, optional: true },
          ]);
          if (e) throw e;
          //contains informatin about the method to be invoked
          this._methodObject = methodObject;
          //parameter values for the invocation instance
          this._param = paramValue;
          //parameter values for the invocation instance which are trusted
          this._trustedParams = trustedParams;
          //contains the caller context and callback method after the invocation is finished
          this._invokeCompleteCallback = invokeCompleteCallback;
          //contains the calle's eventHandlerProxyList object
          this._eventHandlerProxyList = eventHandlerProxyList;
          //contains the conversationId
          this._conversationId = conversationId;
          //contains the eventName for register/unregister event method
          this._eventName = eventName;
        }
        invoke() {
          try {
            //check the Invoke type, handle each kind of invocation
            //make sure all exception caught here, and don't bubble up to abort
            //the timer. The exceptions will be packed and sent to caller
            var result;
            switch (this._methodObject.getInvokeType()) {
              case Microsoft.Office.Common.InvokeType.async:
                //the called method will send back the result
                this._methodObject.getMethod()(
                  this._param,
                  this._invokeCompleteCallback.getSend(),
                  this._trustedParams,
                );
                break;
              case Microsoft.Office.Common.InvokeType.sync:
                result = this._methodObject.getMethod()(this._param, this._trustedParams);
                //send back the method call result
                this._invokeCompleteCallback.getSend()(result);
                break;
              case Microsoft.Office.Common.InvokeType.syncRegisterEvent:
                //create an eventHanderObject
                var eventHandlerProxy = this._createEventHandlerProxyObject(this._invokeCompleteCallback);
                //register eventHandlerProxy's send method with event registration method
                //this._param is optional
                result = this._methodObject.getMethod()(eventHandlerProxy.getSend(), this._param, this._trustedParams);
                //add the eventHandlerProxy's send method into eventhandlerProxyList, to be used later by unregister
                this._eventHandlerProxyList[this._conversationId + this._eventName] = eventHandlerProxy.getSend();
                //send back the registeration result
                this._invokeCompleteCallback.getSend()(result);
                break;
              case Microsoft.Office.Common.InvokeType.syncUnregisterEvent:
                //get an eventHander method
                var eventHandler = this._eventHandlerProxyList[this._conversationId + this._eventName];
                //unregister the eventHandler with event unregistration method
                //this._param is optional
                result = this._methodObject.getMethod()(eventHandler, this._param, this._trustedParams);
                //remove from eventHandlerProxyList
                delete this._eventHandlerProxyList[this._conversationId + this._eventName];
                //send back the registeration result
                this._invokeCompleteCallback.getSend()(result);
                break;
              case Microsoft.Office.Common.InvokeType.asyncRegisterEvent:
                //create an eventHanderObject
                var eventHandlerProxyAsync = this._createEventHandlerProxyObject(this._invokeCompleteCallback);
                //register eventHandlerProxyAsync's send method with event registration async method
                //this._param is optional
                this._methodObject.getMethod()(
                  eventHandlerProxyAsync.getSend(), //eventhandler - the proxy
                  this._invokeCompleteCallback.getSend(), //eventRegistractionCallback - the proxy
                  this._param, //param for registerEventMethod
                  this._trustedParams,
                );
                //add the eventHandlerProxyAsync's send method into eventhandlerProxyList, to be used later by unregister
                this._eventHandlerProxyList[this._callerId + this._eventName] = eventHandlerProxyAsync.getSend();
                //the registeration result will be sent back in eventRegistractionCallback
                break;
              case Microsoft.Office.Common.InvokeType.asyncUnregisterEvent:
                //get an eventHander method
                var eventHandlerAsync = this._eventHandlerProxyList[this._callerId + this._eventName];
                //unregister the eventHandlerAsync with event unregistration method
                //this._param is optional
                this._methodObject.getMethod()(
                  eventHandlerAsync, //eventhandler - on the proxy side
                  this._invokeCompleteCallback.getSend(), //eventUnregistristrationCallback - on the proxy side
                  this._param, //param for unregisterEventMethod
                  this._trustedParams,
                );
                //remove from eventHandlerProxyList
                delete this._eventHandlerProxyList[this._callerId + this._eventName];
                //the result will be sent back via eventUnregistrationCallback, the listener gets removed
                //the from XDM because of the line above
                break;
              default:
                break;
            }
          } catch (ex) {
            //construct a response object with error, send it back to caller
            //just set error code, pass in ex as a result, let getSend() construct and send the response.
            this._invokeCompleteCallback.setResultCode(Microsoft.Office.Common.InvokeResultCode.errorInResponse);
            this._invokeCompleteCallback.getSend()(ex);
          }
        }
        getInvokeBlockingFlag() {
          return this._methodObject.getBlockingFlag();
        }
        _createEventHandlerProxyObject(invokeCompleteObject) {
          return new Microsoft.Office.Common.ResponseSender(
            invokeCompleteObject.getRequesterWindow(),
            invokeCompleteObject.getRequesterUrl(),
            invokeCompleteObject.getActionName(),
            invokeCompleteObject.getConversationId(),
            invokeCompleteObject.getCorrelationId(),
            Microsoft.Office.Common.ResponseType.forEventing,
          );
        }
      }
    }
  }
}
